import { render } from "./AppHeader.vue?vue&type=template&id=6aa2730f"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=6aa2730f&lang=css"

import exportComponent from "/Users/krisflajs/Projects/DDStudios/DDS-platform/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__